type DeviceOrientation = "portrait" | "landscape";
type ResolutionDefinition = {
  [key in DeviceOrientation]: {
    width: number;
    height: number;
  };
};
export const VIDEO_RESOLUTION: ResolutionDefinition = {
  landscape: { width: 640, height: 360 },
  portrait: { width: 288, height: 360 },
};
export const VIDEO_ASPECT_RATIO: { [key in DeviceOrientation]: string } = {
  landscape: "16 / 9",
  portrait: "4 / 5",
};
